import { addCpfMask, EmailLink } from '@repo/ui';
import { UserData, ADMINISTRATORS_ORDER_COLUMNS } from 'domain/value-objects';
import { TableColumn } from 'react-data-table-component';

export const makeAdministratorsListColumns = (): TableColumn<UserData>[] => {
  return [
    {
      name: 'CPF',
      width: '180px',
      sortable: true,
      sortField: ADMINISTRATORS_ORDER_COLUMNS.CPF,
      selector: (row) => addCpfMask(row.cpf),
    },
    {
      name: 'Nome',
      sortable: true,
      sortField: ADMINISTRATORS_ORDER_COLUMNS.NAME,
      selector: (row) => row.name,
    },
    {
      name: 'Email',
      selector: (row) => row.email,
      sortable: true,
      sortField: ADMINISTRATORS_ORDER_COLUMNS.EMAIL,
      cell: (row) => <EmailLink email={row.email} />,
    },
    {
      name: 'Perfil',
      sortable: false,
      selector: (row) => row.role?.name,
    },
  ];
};
